import React from 'react'
import { Outlet } from 'react-router-dom';

const MenuMngPage = () => {
  return <Outlet/>
}

export default MenuMngPage